import React, { ReactElement } from "react"

function addPropsToReactElement(element: ReactElement, props: any) {
    if (React.isValidElement(element)) {
        return React.cloneElement(element, props)
    }
    return element
}

export function addPropsToChildren(children: any, props: any) {
    if (!Array.isArray(children)) {
        return addPropsToReactElement(children, props)
    }
    return children.map(childElement =>
        addPropsToReactElement(childElement, props)
    )
}